export const ApiEventPermissions = {
  read: "Event.Read",
  readWrite: "Event.ReadWrite"
};

export const ApiEventTemplatesPermissions = {
  read: "EventTemplate.Read",
  readWrite: "EventTemplate.ReadWrite"
};

export const ApiOccasionsPermissions = {
  read: "Occasion.Read",
  readWrite: "Occasion.ReadWrite"
};

export const ApiNoticePermissions = {
  read: "Notice.Read",
  readWrite: "Notice.ReadWrite"
};

export const ApiResidentPermissions = {
  read: "Resident.AccountManagement.Read",
  readWrite: "Resident.AccountManagement.ReadWrite"
};

export const ApiAnnouncementPermissions = {
  readWrite: "Announcement.ReadWrite"
};

export const ApiReleasedEventPermissions = {
  delete: "ReleasedEvent.Delete"
};

export const ApiProcessedBookingPermissions = {
  read: "ProcessedBooking.Read"
};

export const ApiMetricsPermissions = {
  read: "Metrics.Read"
};
